/* React and Next */
import React from 'react';
import Image from 'next/image';

/* Material UI */
import {
  AppBar, Grid, Toolbar, Container, Link,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

/* Icons */
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

/* Style */
const useStyles = makeStyles((theme) => ({
  loginHeader: {
    backgroundColor: theme.palette.greyScale.superlight,
    boxShadow: 'none',
  },
  users: {
    color: theme.palette.secondary.main,
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    '& > *': {
      marginRight: theme.spacing(1),
    },
  },
  link: {
    marginTop: theme.spacing(1),
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
}));

const Appbar: React.FC = () => {
  const classes = useStyles();
  return (
    <>
      <AppBar position="static" className={classes.loginHeader}>
        <Container>
          <Toolbar>
            <Grid container className={classes.users}>
              <Link href="https://www.wixdom.io" className={classes.link}>
                {/* href="https://www.wixdom.io" */}
                <ArrowBackIcon fontSize="large" />
                <Image
                  src="/logo_normal.png"
                  alt="Logo Wixdom"
                  height="67px"
                  width="200px"
                />
              </Link>
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default Appbar;
